import "./Testimonials.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    id: 1,
    name: "Rajesh Patil",
    company: "Patil Industries",
    image: "https://i.pravatar.cc/150?img=11",
    review:
      "Potech Technologies developed our company website with excellent design and performance. Their support is outstanding."
  },

  {
    id: 2,
    name: "Amit Deshmukh",
    company: "AD Construction",
    image: "https://i.pravatar.cc/150?img=15",
    review:
      "Professional team, timely delivery and quality work. Highly recommended for business websites."
  },

  {
    id: 3,
    name: "Sneha Kulkarni",
    company: "EduTech Academy",
    image: "https://i.pravatar.cc/150?img=32",
    review:
      "Our School ERP project was completed perfectly. Great communication throughout the project."
  }
];

function Testimonials() {

  return (

<section className="testimonials">

<div className="container">

<div className="section-title">

<h2>What Our Clients Say</h2>

<p>

Trusted by startups, schools, businesses and organizations.

</p>

</div>

<Swiper

modules={[Autoplay, Pagination]}

spaceBetween={30}

slidesPerView={1}

loop={true}

pagination={{ clickable: true }}

autoplay={{

delay:4000,

disableOnInteraction:false

}}

breakpoints={{

768:{slidesPerView:2},

1200:{slidesPerView:3}

}}

>

{

testimonials.map((item)=>(

<SwiperSlide key={item.id}>

<div className="testimonial-card">

<img src={item.image} alt={item.name} />

<h3>{item.name}</h3>

<span>{item.company}</span>

<div className="stars">

★★★★★

</div>

<p>

"{item.review}"

</p>

</div>

</SwiperSlide>

))

}

</Swiper>

</div>

</section>

);

}

export default Testimonials;